import React, {useEffect, useState} from 'react';
import RenderHtml from 'react-native-render-html';
import {useRoute} from '@react-navigation/native';
import {useInnerStyle} from './promotion.hooks';
import {FadeInView} from '@basicComponents/animations';
import DetailNavTitle from '@businessComponents/detail-nav-title';
import {goBack, goToByUri} from '@utils';
import {PromotionListItem, getPromotionList} from './promotion.service';
import {ScrollView, View} from 'react-native';
import theme from '@/style';
import Text from '@basicComponents/text';
import Button from '@basicComponents/button';
import globalStore from '@/services/global.state';
import {useTranslation} from 'react-i18next';
import {goToUrl} from '@/common-pages/game-navigate';
import {BasicObject} from '@/types';
import {getPromotionDetailRouteId} from './promotion-detail.utils';

const findPromotionById = async (id: string) => {
  let pageNo = 1;
  let totalPages = 1;

  while (pageNo <= totalPages) {
    const pageInfo = await getPromotionList(pageNo);
    const target = pageInfo?.content?.find(item => String(item.id) === id);

    if (target) {
      return target;
    }

    totalPages = pageInfo?.totalPages || pageNo;
    pageNo++;
  }
};

const PromotionDetail = () => {
  const {i18n} = useTranslation();
  const route = useRoute();
  const routeParams = (route.params || {}) as BasicObject;
  const promotionId = getPromotionDetailRouteId(routeParams.id);
  const [item, setItem] = useState<PromotionListItem>();
  const {
    size: {screenHeight, screenWidth, designWidth},
    itemStyle,
    listStyle,
    detailStyle,
  } = useInnerStyle();

  useEffect(() => {
    if (promotionId) {
      globalStore.globalLoading.next(true);
      findPromotionById(promotionId)
        .then(target => {
          setItem(target);
          if (target) {
            globalStore.asyncSetItem(
              'promotion-detail',
              JSON.stringify(target),
            );
          }
        })
        .finally(() => {
          globalStore.globalLoading.next(false);
        });
      return;
    }

    globalStore.asyncGetItem('promotion-detail').then(_item => {
      if (_item) {
        try {
          setItem(JSON.parse(_item) as PromotionListItem);
        } catch {
          setItem(undefined);
        }
      }
    });
  }, [promotionId]);

  const handleHtmlLinkPress = (
    _event: unknown,
    href: string,
    htmlAttribs: Record<string, string>,
  ) => {
    const nextUrl = (htmlAttribs.href || href || '').trim();

    if (!nextUrl) {
      return;
    }

    if (
      nextUrl.startsWith('/') ||
      (nextUrl.startsWith('route:') &&
        !nextUrl.substring('route:'.length).trim().startsWith('{'))
    ) {
      goToByUri(nextUrl);
      return;
    }

    goToUrl(nextUrl, item?.activityTitle);
  };

  const source = {
    html: item?.activityContent || '',
  };
  const htmlStyle = {
    fontSize: theme.fontSize.m,
    lineHeight: theme.fontSize.m * 1.4,
    fontFamily: 'Inter',
    color: theme.fontColor.accent,
  };
  const tagsStyles = {
    p: {
      marginTop: 0,
    },
    img: {
      width: screenWidth - (theme.paddingSize.xxl + theme.paddingSize.l) * 2,
    },
  };

  return (
    <FadeInView style={[{height: screenHeight}, theme.background.lightGrey]}>
      <DetailNavTitle
        title={i18n.t('promotion.title')}
        hideAmount
        hideServer
        onBack={goBack}
      />
      <ScrollView
        style={[
          theme.flex.flex1,
          theme.background.white,
          theme.margin.lrl,
          theme.margin.tbxxl,
          theme.padding.xxl,
          theme.borderRadius.m,
        ]}
        contentContainerStyle={[listStyle.list]}>
        <View style={[theme.flex.center]}>
          <Text
            fontSize={theme.fontSize.xl}
            main
            blod
            style={[theme.margin.btmxxs, detailStyle.title]}>
            {item?.activityTitle}
          </Text>
        </View>
        <RenderHtml
          source={source}
          baseStyle={htmlStyle}
          tagsStyles={tagsStyles}
          renderersProps={{
            a: {
              onPress: handleHtmlLinkPress,
            },
          }}
        />
        {item?.activityUrl && (
          <View style={[theme.fill.fillW, theme.flex.center]}>
            <Button
              titleBold
              buttonStyle={itemStyle.button}
              width={(screenWidth * 96) / designWidth}
              onPress={() => {
                goToUrl(item.activityUrl, item.activityTitle);
              }}>
              <Text
                blod
                fontSize={theme.fontSize.s}
                color={theme.basicColor.white}>
                {i18n.t('promotion.join')}
              </Text>
            </Button>
          </View>
        )}
      </ScrollView>
    </FadeInView>
  );
};

export default PromotionDetail;
